import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs as MuiTabs, Tab } from "@mui/material";
import { useCallback } from "react";
import { useColorPicker } from "../hooks/useColorPicker.js";
function Tabs(props) {
  const { palette, picker } = props;
  const {
    router: {
      route: { id }
    },
    goToPalette,
    goToCustom,
    localeText
  } = useColorPicker();
  const onChangeRoute = useCallback(
    (_, tab) => {
      switch (tab) {
        case "palette": {
          goToPalette();
          break;
        }
        case "custom": {
          goToCustom();
          break;
        }
      }
    },
    [goToCustom, goToPalette]
  );
  if (!palette || !picker || id === "add-color-to-palette") return null;
  return /* @__PURE__ */ jsxs(MuiTabs, { "data-testid": "ColorPicker--Tabs", onChange: onChangeRoute, value: id, variant: "fullWidth", children: [
    /* @__PURE__ */ jsx(Tab, { "data-testid": "TidalColorPickerTabPalette", label: localeText.tabPaletteLabel, value: "palette" }),
    /* @__PURE__ */ jsx(Tab, { "data-testid": "TidalColorPickerTabSpectrum", label: localeText.tabCustomLabel, value: "custom" })
  ] });
}
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
